import React from 'react';
import PropTypes from 'prop-types';
import Map from './Map';
import './ChartMap.scss';
import ChartMapLegend from './ChartMapLegend';
import colors from '../../../../../../../../apps/baykis-pl/pattern-lab/_data/generated-colors.json';

const ChartMap = ({
  size,
  shapePath,
  shape,
  data,
  latLonData,
  colorConfig,
  showCopyright,
  caption,
  showLegend,
  backdrop,
}) => {
  ChartMap.propTypes = {
    size: PropTypes.number,
    shapePath: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired,
    colorConfig: PropTypes.object.isRequired,
    latLonData: PropTypes.array.isRequired,
    showCopyright: PropTypes.bool,
    showLegend: PropTypes.bool,
    backdrop: PropTypes.bool,
    caption: PropTypes.object.isRequired,
  };

  ChartMap.defaultProps = {
    size: 240,
    showCopyright: false,
    showLegend: true,
    backdrop: true,
  };

  return (
    <div className="shape grid__bit -w3-tablet">
      <div className={`${backdrop ? 'map_backdrop' : ''}`}>
        <Map
          size={size}
          colorConfig={colorConfig}
          data={data}
          shape={shape}
          shapePath={shapePath}
          latLonData={latLonData}
        />
        {showLegend && <ChartMapLegend colorConfig={colorConfig} colors={colors} width={size} />}
        <p className={`copyright${showCopyright ? '' : ' hide'}`} >
          ©&nbsp;Bayerisches Klimainformationssystem LfU&nbsp;
          {new Date().getFullYear()}
        </p>
      </div>
      <p className="caption">{caption.firstLine}</p>
      <p className="caption">{caption.secondLine}</p>
    </div>
  );
};

export default React.memo(ChartMap);
